import axios from 'axios';

const API = axios.create({baseURL: 'https://project-allocation-schedule.herokuapp.com'});

export const getProjects = () => API.get('/projects');
export const createProjects = (newProject) => { API.post('/projects', newProject); }
export const updateProject = (id, updatedProject) => API.patch(`/projects/${id}`, updatedProject);
export const deleteProject = (id) => API.delete(`/projects/${id}`);
export const shortlistProject = (id, updatedUser) => API.patch(`/users/${id}`);

export const getLecturerProjects = () => API.get('/lecturerProject');
export const createLecturerProjects = (newProject) => { API.post('/lecturerProject', newProject);}
export const updateLecturerProject = (id, updatedProject) => API.patch(`/lecturerProject/${id}`, updatedProject);
export const deleteLecturerProject = (id) => API.delete(`/lecturerProject/${id}`);

export const logIn = (loginDetails) => { API.post('/users', loginDetails); }
export const createUsers = (newUser) => { API.post('/users', newUser); }
export const getUsers = () => API.get('/users');
export const deleteUsers = (id) => API.delete(`/users/${id}`);
export const updateUsers = (id, updatedUser) => API.patch(`/users/${id}`, updatedUser);

export const createDates = (newDate) => { API.post('/dates', newDate); }
export const getDates = () => API.get('/dates');
export const updateDates = (id, updatedUser) => API.patch(`/dates/${id}`, updatedUser);
export const deleteDates = (id) => API.delete(`/dates/${id}`);

